<div *ngIf="deshabilitado" class="container-fluid">
    <div class="row">
        <div class="col">
            <h4 class="text-center mt-4">Servicio actualmente en pruebas, próximamente habilitado por los clientes de Flex. Permanece atento a nuestros canales en redes sociales</h4>
        </div>
    </div>
</div>

<img class="img-fluid mt-4 mb-4" src="../../../assets/img/compra/imagen-carrusel-02-200p.png" alt="Responsive image">